<template>
  <div id="sov">
    <div
      data-html2canvas-ignore="true"
      v-show="loader || reviewLoader"
    >
      <Loader />
    </div>

    <div class="datepickerwrap card" style="flex-direction: row">
      <div class="leftcontent wrapitem d-flex">
        <div class="custom_dropdown customMultiselect mr-3" style="width:35%">
          <multiselect
            v-model="getSelectedWebsites"
            :options="websiteMenuItems"
            :multiple="true"
            group-values="options"
            group-label="optgroup"
            :group-select="true"
            placeholder="Search Website(s)"
            track-by="key"
            label="label"
            select-label=""
            deselect-label=""
            selectedLabel=""
            :closeOnSelect="false"
            selectGroupLabel="Select Group"
            deselectGroupLabel="Deselect Group"
            @select="setSelectedWebsites($event)"
            @remove="removeSelectedWebsites($event)"
          >
            <template slot="option" slot-scope="{ option }">
              <div v-if="option.$isLabel">
                <strong>{{ option.$groupLabel }}</strong>
              </div>
              <div v-else>
                <input
                  type="checkbox"
                  :value="option"
                  v-model="getSelectedWebsites"
                />
                <span class="option__title ml-3">{{ option.label }}</span>
              </div>
            </template>
          </multiselect>
        </div>
        <div class="datebox" style="width: 10% !important;">
          <button class="btn primarycolor" @click="clearBrandStorage">
            Reset
          </button>
        </div>
        <div class="datebox">
          <select
            v-model="device"
            @change="siteDeviceChange"
            class="form-control text-uppercase"
          >
            <option
              v-if="
                !selected_website_array.every(website =>
                  onlyCpuGpuSites.includes(website)
                )
              "
              value="laptop"
            >
              Laptop
            </option>
            <option
              v-if="
                !selected_website_array.every(website =>
                  onlyCpuGpuSites.includes(website)
                )
              "
              value="desktop"
            >
              Desktop
            </option>
            <option
              v-if="
                selected_website_array.some(website =>
                  cpuGpuSites.includes(website)
                )
              "
              value="gpu"
            >
              GPU
            </option>
            <option
              v-if="
                selected_website_array.some(website =>
                  cpuGpuSites.includes(website)
                )
              "
              value="cpu"
            >
              CPU
            </option>
          </select>
          <!-- 'every' in js checks for all the array value if returns true if all are true, opposite for 'some' -->
        </div>
        <div class="datebox" style="width: 12% !important">
          <button
            @click="siteDeviceChange"
            class="btn primarycolor"
            type="button"
          >
            <span>Submit</span>
          </button>
        </div>
        <div class="datebox custom_dropdown" v-if="!compCheck">
          <div
            @click="showProductModal"
            class="custom_dropdown_wrap"
            style="
              background: white;
              padding-left: 14px;
              border: 1px solid var(--base_color-40);
              border-radius: 5px;
              margin-left: -5px;
              padding-right: 14px;
              height: 2.2rem;
            "
          >
            <span
              class="custom_dropdown_title"
              style="
                margin-top: 0px;
                float: left;
                font-size: 12px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 201px;
              "
              >{{
                allReviewProductsCheck ? "All" : selectedProduct[0]
              }}
              &nbsp;</span
            >
            <i style="font-size: 17px" class="fa fa-angle-down"></i>
          </div>
        </div>
        <div class="datebox">
          <datepicker
            placeholder="From"
            @input="refreshReview"
            v-model="reviewStartDate"
          />
        </div>
        <div class="datebox">
          <datepicker
            v-model="reviewEndDate"
            class="picker-left"
            placeholder="To"
            @input="refreshReview"
          />
        </div>
        <!-- <div
          style="width: 25%; text-align: center; background-color: var(--primary_brand); height: 35px; padding-top: 6px;"
          class="btn text-white font-weight-bold checkboxAccent" @click="getCompPage">
          <input v-model="compCheck" style="float: left; margin-top: 2.5px;" type="checkbox" />
          <span> Competitor Analysis </span>
        </div> -->
      </div>
      <div class="righcontent wrapitem">
        <button
          @click="backToSov"
          style="float: right"
          class="btn navigationButton"
          type="button"
        >
          <img
            src="Icons_SVG/Arrow_Left.svg"
            height="16"
            class="backIcon"
            style="margin-top: -3px"
          />
          <span style="font-size: 16px"> Back</span>
        </button>
        <button
          @click="goToSentiments"
          style="float: right; margin-right: 5px"
          class="btn navigationButton"
          type="button"
        >
          <span style="font-size: 16px">Show Sentiments</span>
        </button>
      </div>
    </div>
    <div class="container-fluid">
      <div class="card" style="padding: 20px" v-if="reviewTableDataFlag">
        <b-row class="mt-1 ml-1 mb-2">
          <div
            style="display: flex; justify-content: flex-start"
            class="col-md-6"
          >
            <div class="col-md-*">
              <p
                class="inputBoxTitle"
                style="margin-bottom: 0; padding: 7px; margin-left: -20px"
              >
                Ratings:
              </p>
            </div>
            <div class="col-md-3 px-0 mr-2">
              <select
                v-model="reviewsRatingExp"
                class="form-control text-uppercase"
              >
                <option value="eq">Equals to (=)</option>
                <option value="gt">Greater than (&gt;)</option>
                <option value="gte">Greater than equals to (&gt;=)</option>
                <option value="lt">Lower than</option>
                <option value="lte">Lower than equals to (&lt;=)</option>
                <option value="between"
                  >Between (&gt;= &amp;&amp; &lt;=)</option
                >
              </select>
            </div>
            <div class="col-md-3 px-0 mr-2">
              <input
                v-model="reviewsRatingInput"
                style="border: 1px solid silver !important"
                class="form-control filval"
                type="text"
                placeholder="Enter Value"
              />
              <input
                v-if="reviewsRatingExp == 'between'"
                v-model="reviewsRatingInput2"
                style="border: 1px solid silver !important"
                class="form-control filval"
                type="text"
                placeholder="Enter Value"
              />
            </div>
            <div class="col-md-1 pl-0">
              <button @click="refreshReview" class="btn exportButton">
                Apply
              </button>
            </div>
          </div>
          <div class="col-md-6 pl-0" style="text-align: right">
            <span
              style="position: relative; top: 2px; height: 35px !important;"
              class="lastUpdated mr-1"
            >
              Last Updated:
              {{ moment(reviewsData.last_updated).format("MMM DD, YY") }}
            </span>
            <button @click="exportData" class="btn exportButton mr-1">
              Export
            </button>
          </div>
        </b-row>
        <table id="amdglobal-review-listTable">
          <thead class="thead-normal">
            <tr>
              <th style="width: 9%">Partner</th>
              <th style="width: 18%">Product Name</th>
              <th style="width: 7%">Review<br />Date</th>
              <th style="width: 5%">Rating</th>
              <th>Review Text</th>
              <th style="width: 6%">Overall Rating</th>
              <th style="width: 6%">Total Reviews</th>
              <th style="width: 8%">{{ device === "gpu" ? "GPU" : "CPU" }}</th>
              <th style="width: 4%">
                {{ device === "gpu" ? "GPU Model" : "CPU Model" }}
              </th>
              <th v-show="checkGPUFlag">GPU</th>
              <th v-show="checkGPUFlag">GPU Model</th>
              <th v-show="checkGPUFlag">Verified Review</th>
              <th style="width: 7%">Review Link</th>
            </tr>
          </thead>
          <tfoot style="display: table-row-group">
            <tr>
              <th style="width: 9%">Partner</th>
              <th style="width: 18%">Product Name</th>
              <th style="width: 7%">Review<br />Date</th>
              <th style="width: 5%">Rating</th>
              <th>Review Text</th>
              <th style="width: 6%">Overall Rating</th>
              <th style="width: 6%">Total Reviews</th>
              <th style="width: 8%">{{ device === "gpu" ? "GPU" : "CPU" }}</th>
              <th style="width: 4%">
                {{ device === "gpu" ? "GPU Model" : "CPU Model" }}
              </th>
              <th v-show="checkGPUFlag" style="text-transform: capitalize">
                GPU
              </th>
              <th v-show="checkGPUFlag" style="text-transform: capitalize">
                GPU Model
              </th>
              <th v-show="checkGPUFlag">Verified Review</th>
              <th style="width: 7%"></th>
            </tr>
          </tfoot>
          <tbody class="tbody-normal" style="font-family: inherit">
            <tr v-for="(d, i) in reviewsData.data">
              <td :data-order="d.channel">{{ d.channel }}</td>
              <td>
                <div
                  style="
                    text-align: left;
                    width: 200px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  <a
                    :title="d.product_name"
                    :href="d.product_link"
                    target="_blank"
                    >{{ d.product_name }}</a
                  >
                </div>
              </td>
              <td :data-order="d.review_date">{{ d.review_date }}</td>
              <td :data-order="d.rating">{{ d.rating }}</td>
              <td
                :data-order="d.review"
                style="text-align: left; min-width: 200px"
              >
                <span v-show="d.review.length < 185">{{ d.review }}</span>
                <span v-show="d.review.length >= 185">
                  <span v-show="!reviewLayoutExpand.includes(i)"
                    >{{ d.review.slice(0, 185) }}...</span
                  >
                  <span v-show="reviewLayoutExpand.includes(i)">{{
                    d.review
                  }}</span>
                  <span
                    @click="expandReview(i)"
                    v-show="!reviewLayoutExpand.includes(i)"
                    style="color: #167495; cursor: pointer"
                    >Expand</span
                  >
                  <span
                    @click="collapseReview(i)"
                    v-show="reviewLayoutExpand.includes(i)"
                    style="color: #167495; cursor: pointer"
                  >
                    Collapse</span
                  >
                </span>
              </td>
              <td :data-order="d.product_rating">{{ d.product_rating }}</td>
              <td :data-order="d.review_count">{{ d.review_count }}</td>
              <td :data-order="d.cpu" style="text-transform: capitalize">
                {{ d.cpu.replace("amd", "AMD") }}
              </td>
              <td :data-order="d.processor_model">{{ d.processor_model }}</td>
              <td
                v-show="checkGPUFlag"
                :data-order="d.gpu"
                style="text-transform: capitalize"
              >
                {{ formatGPU(d.gpu) }}
              </td>
              <td
                v-show="checkGPUFlag"
                :data-order="d.gpu_type"
                style="text-transform: capitalize"
              >
                {{ formatGPU(d.gpu_type) }}
              </td>
              <td
                v-show="checkGPUFlag"
                :data-order="d.is_verfied_product"
                style="text-transform: capitalize"
              >
                {{ d.is_verfied_product ? "Yes" : "No" }}
              </td>
              <td>
                <a :href="d.review_link" target="_blank">
                  <i class="fa fa-external-link" style="font-size: 14px"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card" v-else>
        <h4 class="noDataWarning">No Data Available!</h4>
      </div>
      <!-- <div v-if="compCheck">
        <div class="card">
          <h4 class="graphHeading" style="margin-bottom: 12px !important;">Avg. Star Rating by Category</h4>
          <div>
            <table id="competitor_table" style="width: 100%;">
              <thead>
                <tr>
                  <th v-for="header of competitorTableHeader" :key="header.key"> {{ header.value }} </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row of competitorTableData" :key="row.key">
                  <td v-for="header of competitorTableHeader" :key="header.key"> {{ row[header.key] }} </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div> -->
      <div>
        <div class="card" v-if="countDataFlag">
          <div>
            <highcharts
              v-if="activeMultiChart"
              :options="multiProdChart"
            ></highcharts>
          </div>
        </div>
        <div class="card" v-if="percentDataFlag">
          <div>
            <highcharts
              v-if="activeMultiChart"
              :options="percentChart"
            ></highcharts>
          </div>
        </div>
        <b-row>
          <b-col sm="6" lg="6" class="mycols">
            <div class="card" v-if="allKeywordDataFlag">
              <div>
                <highcharts
                  v-if="activeMultiChart"
                  :options="keyWordPieChart"
                ></highcharts>
              </div>
            </div>
          </b-col>
          <b-col sm="6" lg="6">
            <div class="card" v-if="allRatingDataFlag">
              <div>
                <highcharts
                  v-if="activeMultiChart"
                  :options="ratingPieChart"
                ></highcharts>
              </div>
            </div>
          </b-col>
          <b-col sm="12" lg="12">
            <div class="card" v-if="countDataFlag">
              <div style="text-align: right">
                <button
                  style="margin-bottom: 0.75rem !important"
                  @click="exportCPUFamilyTable"
                  class="btn exportButton"
                >
                  Export
                </button>
              </div>
              <table
                v-if="reviewsData.hasOwnProperty('graph_data')"
                id="keyword_newtable"
                class="table"
              >
                <thead>
                  <tr>
                    <th
                      rowspan="2"
                      style="border-top-left-radius: 10px !important"
                    >
                      Theme
                    </th>
                    <th rowspan="2">Count</th>
                    <th
                      colspan="11"
                      style="border-top-right-radius: 10px !important"
                    >
                      CPU Family
                    </th>
                  </tr>
                  <tr>
                    <th
                      v-for="th in reviewsData.graph_data.count_data[0].models"
                      :key="'table_th_' + th.name"
                    >
                      {{ th.name }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="d in reviewsData.graph_data.count_data"
                    :key="'table_keywords_' + d.keyword"
                  >
                    <td
                      style="background: var(--secondary_competitor-10) !important"
                    >
                      {{ d.keyword }}
                    </td>
                    <td>{{ d.total }}</td>
                    <td v-for="d2 in d.models" :key="'table_td_' + d2.name">
                      {{ d2.count }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-modal
      size="lg"
      title="Select  "
      v-model="isProductModal"
      class="customModal"
    >
      <b-row>
        <div class="col-md-12">
          <div style="display: flex" class="searchInput">
            <input
              style="border-radius: 0; padding: 6px; font-size: 11px"
              class="form-control"
              v-model="schProduct"
              type="text"
              placeholder="Search"
            />
            <div class="searchIcon">
              <img src="Icons_SVG/Search.svg" />
            </div>
          </div>
        </div>
      </b-row>
      <b-row class="pt-2">
        <div class="col-md-12 mb-1">
          <div class="row">
            <div class="col-md-2">
              <p class="mt-1 inputBoxTitle">OEM:</p>
            </div>
            <div class="col-md-10 customMultiselect">
              <multiselect
                v-model="checkedOemReviewsBrands"
                :options="
                  filterKeys.brand.map(data => {
                    return { label: data };
                  })
                "
                :multiple="true"
                :searchable="false"
                placeholder="Select Brand(s)"
                label="label"
                track-by="label"
                selectLabel=""
                @input="changeFilter"
              />
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-2 mt-1">
              <p class="inputBoxTitle">Processor:</p>
            </div>
            <div class="col-md-10 customMultiselect">
              <multiselect
                v-model="checkedReviewsProcessors"
                :options="
                  filterKeys.processor_type.map(data => {
                    return { label: data };
                  })
                "
                :multiple="true"
                :searchable="false"
                placeholder="Select Processor(s)"
                label="label"
                track-by="label"
                selectLabel=""
                @input="changeFilter"
              />
            </div>
          </div>
        </div>
      </b-row>
      <b-row class="pt-1">
        <div class="col-md-2">
          <p class="mt-1 inputBoxTitle">Ratings:</p>
        </div>
        <div class="ratingSection col-md-10">
          <div class="ratingSectionItem mr-1">
            <select v-model="ratingExp" class="form-control text-uppercase">
              <option value="eq">Equals to (=)</option>
              <option value="gt">Greater than (&gt;)</option>
              <option value="gte">Greater than equals to (&gt;=)</option>
              <option value="lt">Lower than</option>
              <option value="lte">Lower than equals to (&lt;=)</option>
              <option value="between">Between (&gt;= &amp;&amp; &lt;=)</option>
            </select>
          </div>
          <div class="pl-0 mx-1 ratingSectionItem">
            <input
              min="0"
              max="5"
              v-model="ratingInput1"
              style="border: 1px solid silver !important"
              class="form-control filval"
              type="number"
              placeholder="Enter Value"
            />
          </div>
          <div v-if="ratingExp == 'between'" class="mx-1 ratingSectionItem">
            <input
              min="0"
              max="5"
              v-model="ratingInput2"
              style="border: 1px solid silver !important"
              class="form-control filval"
              type="number"
              placeholder="Enter Value"
            />
          </div>
          <div class="pl-1">
            <button
              @click="applyRatingFilter"
              class="btn btn primarycolor mx-1"
            >
              Apply
            </button>
            <button
              @click="removeRatingFilter"
              class="btn primarycolor mx-1"
              style="background-color: var(--red); padding-right: 7px; padding-left: 7px"
            >
              Remove
            </button>
          </div>
        </div>
      </b-row>
      <b-row style="margin-top: 15px; padding-right: 5px">
        <div class="col-md-3 pr-0">
          <div class="checkbox-btn">
            <input
              @change="changeFilter"
              v-model="fourKSeries"
              type="checkbox"
            />
            <span>4000 Series</span>
          </div>
        </div>
        <div class="col-md-3 pr-0 pl-1">
          <div class="checkbox-btn">
            <input
              @change="changeFilter"
              v-model="fiveKSeries"
              type="checkbox"
            />
            <span>5000 Series</span>
          </div>
        </div>
        <div class="col-md-3 pr-0 pl-1">
          <div class="checkbox-btn">
            <input
              @change="changeFilter"
              v-model="sixKSeries"
              type="checkbox"
            />
            <span>6000 Series</span>
          </div>
        </div>
        <div class="col-md-3 pl-1">
          <div class="checkbox-btn">
            <input
              @change="changeFilter"
              v-model="sevenSeries"
              type="checkbox"
            />
            <span>7000 Series</span>
          </div>
        </div>
      </b-row>
      <div
        class="space-between-header"
        style="padding-top: 20px; align-items: center"
      >
        <h5 class="m-0 graphHeading" style="margin-bottom: 0px !important">
          Products:
        </h5>
        <button class="btn primarycolor" @click="selectProductNow()">
          Apply
        </button>
      </div>
      <div class="productScroll">
        <div class="eachProduct productListCheckbox" style="padding: 4px">
          <div style="width: 20px; height: 20px; margin-right: 10px;">
            <input
              type="checkbox"
              class="mr-1"
              value="all"
              @click="processAllProductChecking($event)"
              v-model="allReviewProductsCheck"
            />
          </div>
          <div>All</div>
        </div>
        <div
          :class="{ selectedProduct: selectedProduct.key == d.key }"
          v-if="checkSearchFilter(d.key)"
          class="eachProduct productListCheckbox"
          style="padding: 4px"
          :key="d.key"
          v-for="d in productOptions"
        >
          <div style="width: 20px; height: 20px; margin-right: 10px;">
            <input
              type="checkbox"
              class="mr-1"
              :value="d.key"
              @click="processProductChecking($event)"
              :checked="
                allReviewProductsCheck
                  ? true
                  : checkedReviewsProducts.includes(d.key)
              "
            />
          </div>
          <div
            style="
              color: white;
              background: #548f92;
              margin-right: 10px;
              padding: 4px;
              border-radius: 5px;
              text-align: center;
            "
          >
            {{ d.channel_name }}
          </div>
          <div>{{ d.key }}</div>
        </div>
      </div>
    </b-modal>
    <b-modal
      size="xl"
      :title="keywordModalTitle"
      v-model="isKeywordTableModal"
      class="customModal"
    >
      <button
        style="position: absolute; right: 18px; top: 12px; z-index: 999"
        @click="exportModalKeywordTable"
        class="btn exportButton"
      >
        Export
      </button>
      <table
        id="amd-global-review-listkeywordTableModalTable"
        style="margin-top: 45px !important"
      >
        <thead class="thead-normal">
          <tr>
            <th style="width: 9%">Partner</th>
            <th style="width: 18%">Product Name</th>
            <th style="width: 7%">Review<br />Date</th>
            <th style="width: 5%">Rating</th>
            <th>Review Text</th>
            <th style="width: 6%">Overall Rating</th>
            <th style="width: 6%">Total Reviews</th>
            <th style="width: 8%">CPU</th>
            <th style="width: 4%">CPU Model</th>
          </tr>
        </thead>
        <tfoot style="display: table-row-group">
          <tr>
            <th style="width: 9%">Partner</th>
            <th style="width: 18%">Product Name</th>
            <th style="width: 7%">Review<br />Date</th>
            <th style="width: 5%">Rating</th>
            <th>Review Text</th>
            <th style="width: 6%">Overall Rating</th>
            <th style="width: 6%">Total Reviews</th>
            <th style="width: 8%">CPU</th>
            <th style="width: 4%">CPU Model</th>
          </tr>
        </tfoot>
        <tbody class="tbody-normal" style="font-family: inherit">
          <tr v-for="(d, i) in keywordTableModalData">
            <td :data-order="d.channel">{{ d.channel }}</td>
            <td :data-order="d.product_name">
              <div
                style="
                  text-align: left;
                  width: 200px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                <a :title="d.product_name" :href="d.product_link">{{
                  d.product_name
                }}</a>
              </div>
            </td>
            <td :data-order="d.review_date">{{ d.review_date }}</td>
            <td :data-order="d.rating">{{ d.rating }}</td>
            <td
              :data-order="d.review"
              style="text-align: left; min-width: 200px"
            >
              <span v-show="d.review.length < 185">{{ d.review }}</span>
              <span v-show="d.review.length >= 185">
                <span v-show="!reviewLayoutExpand.includes(i)"
                  >{{ d.review.slice(0, 185) }}...</span
                >
                <span v-show="reviewLayoutExpand.includes(i)">{{
                  d.review
                }}</span>

                <span
                  @click="expandReview(i)"
                  v-show="!reviewLayoutExpand.includes(i)"
                  style="color: #167495; cursor: pointer"
                  >Expand</span
                >
                <span
                  @click="collapseReview(i)"
                  v-show="reviewLayoutExpand.includes(i)"
                  style="color: #167495; cursor: pointer"
                >
                  Collapse</span
                >
              </span>
            </td>
            <td :data-order="d.product_rating">{{ d.product_rating }}</td>
            <td :data-order="d.review_count">{{ d.review_count }}</td>
            <td :data-order="d.cpu" style="text-transform: capitalize">
              {{ d.cpu.replace("amd", "AMD") }}
            </td>
            <td :data-order="d.processor_model">{{ d.processor_model }}</td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";
import Loader from "./Components/Loader.vue"

export default {
  name: "sov",
  components: { Datepicker, Multiselect, Loader },
  data: function() {
    return {
      selected_SOVWebsite: localStorage.selected_SOVWebsite,
      selectedWebsites: [],
      compCheck: false,
      websiteMenuItems: [
        {
          optgroup: "RETAIL",
          options: [
            {
              key: "https://www.amazon.com",
              label: "Amazon US",
              channel: "amazon_US"
            },
            {
              key: "https://www.amazon.fr",
              label: "Amazon France",
              channel: "amazon_france"
            },
            {
              key: "https://www.amazon.co.it",
              label: "Amazon Italy",
              channel: "amazon_italy"
            },
            {
              key: "https://www.amazon.es",
              label: "Amazon Spain",
              channel: "amazon_spain"
            },
            {
              key: "https://www.amazon.co.uk",
              label: "Amazon UK",
              channel: "amazon_uk"
            },
            {
              key: "https://www.amazon.de",
              label: "Amazon Germany",
              channel: "amazon_germany"
            },
            {
              key: "https://www.bestbuy.com",
              label: "Best Buy US",
              channel: "BESTBUY"
            },
            {
              key: "https://www.newegg.com",
              label: "Newegg",
              channel: "newegg"
            },
            {
              key: "https://www.microcenter.com",
              label: "Microcenter",
              channel: "microcenter"
            },
            {
              key: "https://www.costco.com",
              label: "Costco US",
              channel: "costco"
            },
            {
              key: "https://www.currys.co.uk",
              label: "Curry's UK",
              channel: "currys_uk"
            },
            {
              key: "https://www.harveynorman.com.au",
              label: "Harvey Norman AU",
              channel: "harvey"
            },
            { key: "https://global.jd.com", label: "JD GC", channel: "jd" },
            {
              key: "https://www.mediamarkt.de",
              label: "MediaMarkt DE",
              channel: "mediamarkt"
            },
            {
              key: "https://www.walmart.com",
              label: "Walmart US",
              channel: "walmart"
            }
          ]
        },
        {
          optgroup: "CONSUMER OEM",
          options: [
            {
              key: "https://br-store.acer.com",
              label: "Acer Brazil",
              channel: "acer_brazil"
            },
            {
              key: "https://store.acer.com/en-us",
              label: "Acer US",
              channel: "Acer"
            },
            {
              key: "https://store.asus.com/us",
              label: "ASUS US",
              channel: "asus"
            },
            {
              key: "https://www.asus.com/fr",
              label: "ASUS France",
              channel: "asus_france"
            },
            {
              key: "https://www.dell.com/en-au",
              label: "Dell Australia",
              channel: "dell_australia"
            },
            {
              key: "https://www.dell.com/ja-jp",
              label: "Dell Japan",
              channel: "dell_japan"
            },
            {
              key: "https://www.dell.com/en-us",
              label: "Dell US",
              channel: "dell"
            },
            {
              key: "https://www.dell.com/en-uk",
              label: "Dell UK",
              channel: "dell_uk"
            },
            {
              key: "https://store.hp.com/FranceStore",
              label: "HP France",
              channel: "hp_france"
            },
            {
              key: "https://www8.hp.com/jp",
              label: "HP Japan",
              channel: "hp_japan"
            },
            {
              key: "https://store.hp.com/mx-es",
              label: "HP Mexico",
              channel: "hp_mexico"
            },
            {
              key: "https://store.hp.com/UKStore",
              label: "HP UK",
              channel: "hp_uk"
            },
            { key: "https://store.hp.com/us", label: "HP US", channel: "hp" },
            {
              key: "https://www.lenovo.com/au",
              label: "Lenovo Australia",
              channel: "lenovo_australia"
            },
            {
              key: "https://www.lenovo.com/fr",
              label: "Lenovo France",
              channel: "lenovo_france"
            },
            {
              key: "https://www.lenovo.com/de",
              label: "Lenovo Germany",
              channel: "lenovo_germany"
            },
            {
              key: "https://www.lenovo.com/gb",
              label: "Lenovo UK",
              channel: "lenovo_uk"
            },
            {
              key: "https://www.lenovo.com/us",
              label: "Lenovo US",
              channel: "lenovo"
            }
          ]
        },
        {
          optgroup: "COMMERCIAL OEM",
          options: [
            {
              key: "https://store.hp.com/FranceStore#commercial",
              label: "Commercial HP France",
              channel: "hp_france_commercial"
            },
            {
              key: "https://store.hp.com/GermanyStore#commercial",
              label: "Commercial HP Germany",
              channel: "hp_germany"
            },
            {
              key: "https://store.hp.com/UKStore#commercial",
              label: "Commercial HP UK",
              channel: "hp_uk_commercial"
            },
            {
              key: "https://store.hp.com/us#commercial",
              label: "Commercial HP US",
              channel: "hp_commercial"
            },
            {
              key: "https://www.lenovo.com/fr#commercial",
              label: "Commercial Lenovo France",
              channel: "lenovo_france_commercial"
            },
            {
              key: "https://www.lenovo.com/de#commercial",
              label: "Commercial Lenovo Germany",
              channel: "lenovo_germany_commercial"
            },
            {
              key: "https://www.lenovo.com/jp#commercial",
              label: "Commercial Lenovo Japan",
              channel: "lenovo_japan_commercial"
            },
            {
              key: "https://www.lenovo.com/gb#commercial",
              label: "Commercial Lenovo UK",
              channel: "lenovo_uk_commercial"
            },
            {
              key: "https://www.lenovo.com/us#commercial",
              label: "Commercial Lenovo US",
              channel: "lenovo_commercial"
            }
          ]
        },
        {
          optgroup: "COMMERCIAL RESELLER",
          options: [
            {
              key: "https://www.bechtle.com",
              label: "Bechtle",
              channel: "bechtle"
            },
            { key: "https://www.cdw.com", label: "CDW", channel: "cdw" },
            {
              key: "https://www.inmac-wstore.com",
              label: "Inmac",
              channel: "inmac"
            },
            {
              key: "https://www.insight.com/en-US",
              label: "Insight",
              channel: "insight"
            },
            {
              key: "https://www.connection.com",
              label: "PC Connection",
              channel: "pc_connection"
            },
            { key: "https://www.shi.com", label: "SHI", channel: "shi" },
            {
              key: "https://www.technoworld.com",
              label: "TechnoWorld",
              channel: "technoworld"
            }
          ]
        }
      ],
      cpuGpuSites: [
        "https://www.amazon.com",
        "https://www.microcenter.com",
        "https://www.newegg.com",
        "https://www.bestbuy.com"
      ],
      onlyCpuGpuSites: [
        "https://www.newegg.com",
        "https://www.microcenter.com"
      ],
      reviewStarData: [],
      sentimentData: {},
      sentimentChart: {},
      activeSentimentChart: false,
      selectedProduct: {},
      productOptions: [],
      productOptionsFull: [],
      reviewStartDate: moment()
        .subtract(1, "week")
        .format("YYYY-MM-DD"),
      reviewEndDate: moment().format("YYYY-MM-DD"),
      loader: false,
      reviewLoader: false,
      modalTitle: "",
      modalSentimentType: "",
      keywordChartData: {},
      showModal: false,
      modalLoader: false,
      chartDataKey: "original_frequency",
      chartDataMapper: {
        original_score: "Score",
        original_frequency: "Frequency",
        reviews_count: "Reviews Count"
      },
      interval: "month",
      activeModalChart: false,
      modalData: {},
      isProductModal: false,
      schProduct: "",
      reviewLayoutExpand: [],
      deviceMapper: {
        laptop: "PC",
        desktop: "Desktop"
      },
      device: localStorage.selected_category,
      ratingInput1: "",
      ratingExp: "eq",
      ratingInput2: "",
      pickProduct: false,
      filterChanged: false,
      cpuFilter: "",
      brandFilter: "",
      filterKeys: {
        brand: [],
        processor_type: []
      },
      reviewsRatingExp: "eq",
      reviewsRatingInput: "",
      reviewsRatingInput2: "",
      reviewsData: {},
      updateSelectedProduct: false,
      moment: moment,
      fourKSeries: false,
      fiveKSeries: false,
      sixKSeries: false,
      sevenSeries: false,
      selected_website_array: [],
      selected_website_channel_array: [],
      multiProdChart: {},
      activeMultiChart: false,
      percentChart: {},
      isKeywordTableModal: false,
      keywordTableModalData: [],
      keywordModalTitle: "",
      checkedReviewsProcessors: [],
      checkedOemReviewsBrands: [],
      checkedReviewsProducts: [],
      allReviewProductsCheck: true,
      reviewTableDataFlag: true,
      allKeywordDataFlag: true,
      allRatingDataFlag: true,
      countDataFlag: true,
      percentDataFlag: true,
      checkGPUFlag: false,
      modifiedSelectedWebsites: [],
      competitorTableHeader: [],
      competitorTableData: []
    };
  },
  computed: {
    getSelectedWebsites: {
      get() {
        return this.selectedWebsites;
      },
      set() {
        this.selectedWebsites = this.modifiedSelectedWebsites;
      }
    }
  },
  mounted() {
    if (localStorage.selected_SOVWebsite) {
      if (localStorage.selected_websites) {
        this.selectedWebsites = JSON.parse(localStorage.selected_websites);
        this.modifiedSelectedWebsites = JSON.parse(
          localStorage.selected_websites
        );
      } else {
        this.websiteMenuItems.map(dataset => {
          dataset.options.forEach(option => {
            if (localStorage.selected_SOVWebsite === option.key) {
              this.selectedWebsites.push(option);
              this.modifiedSelectedWebsites.push(option);
            }
          });
        });
      }
      this.getSelectedWebsites.forEach(websiteItems => {
        this.selected_website_array.push(websiteItems.key);
        this.selected_website_channel_array.push(websiteItems.channel);
      });
      this.device = localStorage.selected_category;
    } else {
      this.device = "laptop";
      this.selectedWebsites = this.websiteMenuItems[0].options[0];
      this.modifiedSelectedWebsites = this.websiteMenuItems[0].options[0];
    }

    if (localStorage.checkedOemReviewsBrands)
      this.checkedOemReviewsBrands = JSON.parse(
        localStorage.checkedOemReviewsBrands
      );
    if (localStorage.checkedReviewsProcessors)
      this.checkedReviewsProcessors = JSON.parse(
        localStorage.checkedReviewsProcessors
      );
    if (localStorage.checkedReviewsProducts)
      this.checkedReviewsProducts = JSON.parse(
        localStorage.checkedReviewsProducts
      );
    if (localStorage.allReviewProductsCheck)
      this.allReviewProductsCheck = JSON.parse(
        localStorage.allReviewProductsCheck
      );

    if (localStorage.cpuFilter)
      this.cpuFilter = JSON.parse(localStorage.cpuFilter);
    if (localStorage.brandFilter)
      this.brandFilter = JSON.parse(localStorage.brandFilter);
    if (localStorage.ratingExp) this.ratingExp = localStorage.ratingExp;
    if (localStorage.ratingInput1)
      this.ratingInput1 = localStorage.ratingInput1;
    if (localStorage.ratingInput2)
      this.ratingInput2 = localStorage.ratingInput2;
    if (localStorage.fourKSeries)
      this.fourKSeries = JSON.parse(localStorage.fourKSeries);
    if (localStorage.fiveKSeries)
      this.fiveKSeries = JSON.parse(localStorage.fiveKSeries);
    if (localStorage.sixKSeries)
      this.sixKSeries = JSON.parse(localStorage.sixKSeries);
    if (localStorage.sevenSeries)
      this.sevenSeries = JSON.parse(localStorage.sevenSeries);

    if (localStorage.reviewStartDate) {
      this.reviewStartDate = localStorage.reviewStartDate;
      this.reviewEndDate = localStorage.reviewEndDate;
    } else {
      this.reviewStartDate = moment()
        .subtract(2, "month")
        .format("YYYY-MM-DD");
      this.reviewEndDate = this.date.startDate;
    }

    //check if competitor page active
    // if (localStorage.comp_check) {
    // this.compCheck = localStorage.comp_check
    // } else localStorage.setItem("comp_check", this.compCheck)
    // console.log(this.compCheck)
    this.getProducts();
  },
  methods: {
    formatGPU(data) {
      if (data) {
        let str = data
          .split(" ")
          .map(substring => {
            if (substring === "amd") return "AMD";
            else
              return (
                substring.charAt(0).toUpperCase() +
                substring.slice(1).toLowerCase()
              );
          })
          .join(" ");
        return str;
      } else return "N/A";
    },
    checkReviewsGPU() {
      if (
        this.selected_website_channel_array.length === 1 &&
        this.selected_website_channel_array[0] === "BESTBUY" &&
        (this.device === "desktop" || this.device === "laptop")
      ) {
        return true;
      } else return false;
    },
    exportCPUFamilyTable() {
      let self = this;
      let payload = {
        header: [],
        data: [],
        file_type: "keyword_score"
      };
      payload.header = [
        { key: "keyword", label: " " },
        { key: "total", label: " " }
      ];
      for (let [
        i,
        r
      ] of self.reviewsData.graph_data.count_data[0].models.entries()) {
        let label = " ";
        if (i == 0) label = "CPU Family";
        payload.header.push({ key: r.name, label: label });
      }

      for (let [i, r] of self.reviewsData.graph_data.count_data.entries()) {
        if (i == 0) {
          let obj = { keyword: "Theme", total: "Count" };
          for (let [ii, rr] of r.models.entries()) {
            obj[rr.name] = rr.name;
          }
          payload.data.push(obj);
        }
        let obj = { keyword: r.keyword, total: r.total };
        for (let [ii, rr] of r.models.entries()) {
          obj[rr.name] = rr.count;
        }
        payload.data.push(obj);
      }
      const url = "/api/websites/export";
      self.$http.post(url, payload).then(
        response => {
          window.location = response.body.file;
          self.loader = false;
        },
        err => {
          self.loader = false;
          console.log("err", err);
        }
      );
    },
    exportModalKeywordTable() {
      let self = this;
      let payload = {
        header: [],
        data: [],
        file_type: "keyword_review_" + self.keywordModalTitle
      };
      payload.header = [
        { key: "channel", label: "Partner" },
        { key: "product_name", label: "Product Name" },
        { key: "product_link", label: "Product Link" },
        { key: "review_date", label: "Review Date" },
        { key: "rating", label: "Rating" },
        { key: "review", label: "Review Text" },
        { key: "product_rating", label: "Overall Rating" },
        { key: "review_count", label: "Total Reviews" },
        { key: "cpu", label: "CPU" },
        { key: "processor_model", label: "CPU Model" }
      ];
      payload.data = self.keywordTableModalData;

      const url = "/api/websites/export";
      self.$http.post(url, payload).then(
        response => {
          window.location = response.body.file;
          self.loader = false;
        },
        err => {
          self.loader = false;
          console.log("err", err);
        }
      );
    },
    processProductChecking: function(event) {
      this.allReviewProductsCheck = false;
      if (event.target.checked) {
        this.checkedReviewsProducts.push(event.target.value);
      } else {
        this.checkedReviewsProducts.splice(event.target.value, 1);
      }
    },
    processAllProductChecking: function(event) {
      if (event.target.checked) {
        this.checkedReviewsProducts = [];
      } else {
        this.checkedReviewsProducts = [];
      }
    },
    siteDeviceChange() {
      let self = this;
      if (!this.getSelectedWebsites.length) {
        this.$bvToast.toast(`Please select website(s) to get reviews.`, {
          title: "Weavr Sense",
          variant: "danger",
          toaster: "b-toaster-bottom-center",
          autoHideDelay: 3000
        });
        return;
      }
      self.updateSelectedProduct = true;
      this.selected_website_array = [];
      this.selected_website_channel_array = [];
      this.getSelectedWebsites.forEach(websiteItems => {
        this.selected_website_array.push(websiteItems.key);
        this.selected_website_channel_array.push(websiteItems.channel);
      });
      self.getProducts();
    },
    exportData() {
      let self = this;
      self.loader = true;
      setTimeout(function() {
        let payload = {
          start_date: moment(self.reviewStartDate).format("YYYY-MM-DD"),
          end_date: moment(self.reviewEndDate).format("YYYY-MM-DD"),
          interval: self.revInterval,
          client: "AMD",
          item_category: self.device
        };
        if (self.reviewsRatingInput) {
          payload["rating"] = {};
          if (self.reviewsRatingExp != "between") {
            payload["rating"][self.reviewsRatingExp] = self.reviewsRatingInput;
          } else {
            payload["rating"]["lte"] = self.reviewsRatingInput2;
            payload["rating"]["gte"] = self.reviewsRatingInput;
          }
        }

        if (self.selected_SOVWebsite != "all") {
          payload["channel"] = self.selected_website_channel_array;
        }
        const allProductName = JSON.parse(JSON.stringify(self.productOptions));
        const processorSeries = [];
        if (
          self.ratingInput1 ||
          self.fourKSeries ||
          self.fiveKSeries ||
          self.sixKSeries ||
          self.sevenSeries
        ) {
          if (self.fourKSeries) processorSeries.push(4);
          if (self.fiveKSeries) processorSeries.push(5);
          if (self.sixKSeries) processorSeries.push(6);
          if (self.sevenSeries) processorSeries.push(7);
          if (self.pickProduct) {
            if (self.selectedProduct.length)
              payload["product_name"] = self.selectedProduct;
            else {
              payload["product_name"] = allProductName.map(val => val.key);
            }
          } else {
            payload["product_name"] = allProductName.map(val => val.key);
          }
        }
        payload["processor_model"] = processorSeries;

        const url = "/api/reviews/download/amd";
        self.$http.post(url, payload).then(
          response => {
            self.loader = false;
            window.location = response.body.data;
          },
          err => {
            self.loader = false;
            console.log("err", err);
          }
        );
      }, 100);
    },
    expandReview(i) {
      this.reviewLayoutExpand.push(i);
    },
    collapseReview(i) {
      let arIdx = this.reviewLayoutExpand.indexOf(i);
      this.reviewLayoutExpand.splice(arIdx, 1);
    },
    changeFilter() {
      this.pickProduct = false;
      this.selectedProduct = [];
      this.checkedReviewsProducts = [];
      this.allReviewProductsCheck = true;
      this.filterChanged = true;

      if (this.checkedReviewsProcessors) {
        this.cpuFilter = this.checkedReviewsProcessors.map(obj => obj.label);
      }
      if (this.checkedOemReviewsBrands) {
        this.brandFilter = this.checkedOemReviewsBrands.map(obj => obj.label);
      }

      localStorage.allReviewProductsCheck = JSON.stringify(
        this.allReviewProductsCheck
      );
      localStorage.selected_product = JSON.stringify(this.selectedProduct);
      localStorage.checkedReviewsProducts = JSON.stringify(
        this.checkedReviewsProducts
      );
      if (this.cpuFilter)
        localStorage.cpuFilter = JSON.stringify(this.cpuFilter);
      else delete localStorage.cpuFilter;
      if (this.brandFilter)
        localStorage.brandFilter = JSON.stringify(this.brandFilter);
      else delete localStorage.brandFilter;
      if (this.checkedReviewsProcessors)
        localStorage.checkedReviewsProcessors = JSON.stringify(
          this.checkedReviewsProcessors
        );
      else delete localStorage.checkedReviewsProcessors;
      if (this.checkedOemReviewsBrands)
        localStorage.checkedOemReviewsBrands = JSON.stringify(
          this.checkedOemReviewsBrands
        );
      else delete localStorage.checkedOemReviewsBrands;
      if (this.ratingExp) localStorage.ratingExp = this.ratingExp;
      else delete localStorage.ratingExp;
      if (this.ratingInput1) localStorage.ratingInput1 = this.ratingInput1;
      else delete localStorage.ratingInput1;
      if (this.ratingInput2) localStorage.ratingInput2 = this.ratingInput2;
      else delete localStorage.ratingInput2;
      if (this.fourKSeries)
        localStorage.fourKSeries = JSON.stringify(this.fourKSeries);
      else delete localStorage.fourKSeries;
      if (this.fiveKSeries)
        localStorage.fiveKSeries = JSON.stringify(this.fiveKSeries);
      else delete localStorage.fiveKSeries;
      if (this.sixKSeries)
        localStorage.sixKSeries = JSON.stringify(this.sixKSeries);
      else delete localStorage.sixKSeries;
      if (this.sevenSeries)
        localStorage.sevenSeries = JSON.stringify(this.sevenSeries);
      else delete localStorage.sevenSeries;
      this.filterActions();
    },
    setSelectedWebsites(items) {
      // if (this.compCheck) {
      //   return;
      // }

      if (items.length > 0) {
        for (let i = 0; i < items.length; i++) {
          this.modifiedSelectedWebsites.push(items[i]);
        }
      } else {
        this.modifiedSelectedWebsites.push(items);
      }
      if (localStorage.selected_websites)
        localStorage.selected_websites = JSON.stringify(
          this.modifiedSelectedWebsites
        );
      else
        localStorage.setItem(
          "selected_websites",
          JSON.stringify(this.modifiedSelectedWebsites)
        );
    },
    removeSelectedWebsites(items) {
      // if (this.compCheck) {
      //   return;
      // }

      if (items.length > 0) {
        for (let i = 0; i < items.length; i++) {
          const itemIndex = this.selectedWebsites.findIndex(
            item => item.key === items[i].key
          );
          if (itemIndex !== -1) {
            this.selectedWebsites.splice(itemIndex, 1);
          }
        }
      } else {
        const itemIndex = this.selectedWebsites.findIndex(
          item => item.key === items.key
        );
        if (itemIndex !== -1) {
          this.selectedWebsites.splice(itemIndex, 1);
        }
      }
      this.modifiedSelectedWebsites = this.selectedWebsites;
      if (localStorage.selected_websites)
        localStorage.selected_websites = JSON.stringify(
          this.modifiedSelectedWebsites
        );
      else
        localStorage.setItem(
          "selected_websites",
          JSON.stringify(this.modifiedSelectedWebsites)
        );
    },

    clearBrandStorage() {
      // if (this.compCheck) {
      //   return;
      // }
      this.selectedWebsites = [];
      this.modifiedSelectedWebsites = [];
      localStorage.selected_websites = JSON.stringify(this.selectedWebsites);
    },
    removeRatingFilter() {
      this.ratingInput1 = "";
      this.ratingInput2 = "";
      if (localStorage.ratingExp) delete localStorage.ratingExp;
      if (localStorage.ratingInput1) delete localStorage.ratingInput1;
      if (localStorage.ratingInput2) delete localStorage.ratingInput2;
      this.changeFilter();
    },
    applyRatingFilter() {
      let self = this;
      if (self.ratingInput1 > 5) {
        alert("Rating value should be between 0 and 5");
        return false;
      }
      if (self.ratingInput1 < 0) {
        alert("Rating value should be between 0 and 5");
        return false;
      }
      if (self.ratingExp == "between") {
        if (self.ratingInput2 > 5) {
          alert("Rating value should be between 0 and 5");
          return false;
        }
        if (self.ratingInput2 < 0) {
          alert("Rating value should be between 0 and 5");
          return false;
        }
      }
      self.changeFilter();
    },
    checkChannel() {
      const OEMWebsites = [
        "https://www.amazon.com",
        "https://www.amazon.fr",
        "https://www.amazon.co.it",
        "https://www.amazon.es",
        "https://www.amazon.co.uk",
        "https://www.amazon.de",
        "https://www.harveynorman.com.au",
        "https://www.costco.com",
        "https://www.walmart.com",
        "https://global.jd.com",
        "https://www.bestbuy.com",
        "https://www.currys.co.uk",
        "https://www.mediamarkt.de"
      ];

      const hasOEMSite = this.selected_website_array.some(site =>
        OEMWebsites.includes(site)
      );

      if (hasOEMSite) {
        return true;
      } else {
        return false;
      }
    },
    checkSearchFilter(d) {
      let self = this;
      if (d.toLowerCase().indexOf(self.schProduct.toLowerCase()) != -1) {
        return true;
      } else {
        return false;
      }
    },
    goToSentiments() {
      let self = this;
      this.$router.push("/sentiments");
    },
    selectProductNow() {
      let self = this;
      self.selectedProduct = this.checkedReviewsProducts;
      self.pickProduct = true;
      localStorage.selected_product = JSON.stringify(self.selectedProduct);
      localStorage.checkedReviewsProducts = JSON.stringify(
        self.checkedReviewsProducts
      );
      localStorage.allReviewProductsCheck = JSON.stringify(
        this.allReviewProductsCheck
      );
      self.refreshReview();
      self.isProductModal = false;
    },
    showProductModal() {
      let self = this;
      self.isProductModal = true;
    },
    formatDate(key, d) {
      let self = this;
      let obj = {
        day: moment(d).format("MMM DD, YY"),
        month: moment(d).format("MMM YY"),
        week: ""
      };
      if (self[key] == "week") {
        let end_date = moment(d).add(6, "days");
        let today = moment(self.reviewEndDate);
        if (end_date >= today) end_date = today;
        obj["week"] =
          moment(d).format("MMM DD, YY") +
          " - " +
          moment(end_date).format("MMM DD, YY");
      }
      return obj[this[key]];
    },
    backToSov() {
      this.$router.push("/sov");
    },
    changeSentimentType(d) {
      this.$nextTick(function() {
        this.modalSentimentType = d;
        this.getKeywordWiseData();
      });
    },
    getKeywordWiseData() {
      let self = this;
      self.modalLoader = true;
      self.loader = true;
      if (Object.keys(self.modalData).length) {
        $("#amdglobal-review-listTable")
          .DataTable()
          .destroy();
      }
      self.modalData = {};
      let url = "/api/reviews/keywordwise";
      url += "?keyword=" + self.modalTitle;
      url += "&product_name=" + "all";

      url += "&channel=" + self.websitesUrls[self.selected_website];
      if (self.modalSentimentType)
        url += "&sentiment_type=" + self.modalSentimentType;
      url +=
        "&start_date=" +
        this.reviewStartDate +
        "&end_date=" +
        this.reviewEndDate;
      self.$http.get(url).then(
        response => {
          self.modalData = response.body;
          self.modalLoader = false;
          self.loader = false;
          if (!self.showModal) self.showModal = true;
        },
        err => {
          self.modalLoader = false;
          self.loader = false;
          console.log(err);
        }
      );
    },

    processChartData() {
      let category = [];
      let series = [];
      let comm_series = [];
      let datakeys = [
        { key: "positive", label: "Positive", color: "green" },
        { key: "negative", label: "Negative", color: "red" }
      ];
      let self = this;
      let new_key = "";
      let org_label = "";
      let com_label = "";
      if (this.chartDataKey == "original_frequency") {
        new_key = "frequency";
        org_label = "Frequency";
        com_label = "Cummulative Frequency";
      } else if (this.chartDataKey == "original_score") {
        new_key = "score";
        org_label = "Score";
        com_label = "Cummulative Score";
      } else {
        new_key = "cummulative_review_count";
        org_label = "Review Count";
        com_label = "Cummulative Review Count";
      }
      for (let [i, k] of datakeys.entries()) {
        if (this.keywordChartData.data[k.key]) {
          let obj = {};
          obj.name = k.label;
          obj.data = [];
          obj.color = k.color;
          let comm_obj = {};
          let format_date = "";
          comm_obj.name = k.label;
          comm_obj.data = [];
          comm_obj.color = k.color;
          for (let [idx, dataset] of this.keywordChartData.data[
            k.key
          ].entries()) {
            category.push(self.formatDate("interval", dataset.date));
            obj.data.push(dataset[this.chartDataKey]);
            comm_obj.data.push(dataset[new_key]);
          }
          series.push(obj);
          comm_series.push(comm_obj);
        }
      }
      this.plotChart(
        { series: series, category: category },
        "modalChart",
        org_label
      );
      this.plotChart(
        { series: comm_series, category: category },
        "cmodalChart",
        com_label
      );
    },
    plotChart(d, chartObj, chart_label) {
      var self = this;
      if (d.category.length) self.activeModalChart = true;
      else self.activeModalChart = false;
      this[chartObj] = {
        credits: {
          enabled: false
        },
        chart: {
          height: 210
        },
        title: {
          text: ""
        },
        subtitle: {
          text: ""
        },

        yAxis: {
          title: {
            text: chart_label
          }
        },
        xAxis: {
          categories: d.category,
          crosshair: true,
          crosshair: {
            color: "rgba(166, 215, 238)",
            width: 2
          }
        },
        tooltip: {
          formatter: function() {
            var mytooltip = this.points[0].key + "<br/>";
            for (var i = 0; i < this.points.length; i++) {
              mytooltip +=
                '<span style="color:' +
                this.points[i].series.color +
                '">\u25CF</span> ';
              mytooltip += this.points[i].series.name;
              mytooltip +=
                " : <b> " + self.format(this.points[i].y) + "</b> <br/>";
            }
            return mytooltip;
          },
          shared: true
        },
        plotOptions: {
          series: {
            lineWidth: 1.2,
            marker: {
              radius: 1.9
            }
          }
        },
        series: d.series
      };
    },
    refreshModal() {
      let self = this;
      self.reviewStartDate = moment(self.reviewStartDate).format("YYYY-MM-DD");
      self.reviewEndDate = moment(self.reviewEndDate).format("YYYY-MM-DD");
      this.getKeywordChartData();
      this.getKeywordWiseData();
    },
    openModal(keyword, type) {
      this.modalTitle = keyword;
      this.modalSentimentType = type;
      this.refreshModal("datecomponent");
    },
    getKeywordChartData() {
      let self = this;
      self.modalLoader = true;
      self.loader = true;
      self.$nextTick(function() {
        self.keywordChartData = {};
        let url = "/api/reviews/keywisesentdata?interval=" + self.interval;
        url += "&keyword=" + self.modalTitle;
        url += "&product_name=" + "all";
        url += "&channel=" + self.websitesUrls[self.selected_website];
        if (self.modalSentimentType)
          url += "&sentiment_type=" + self.modalSentimentType;

        url +=
          "&start_date=" +
          this.reviewStartDate +
          "&end_date=" +
          this.reviewEndDate;
        self.$http.get(url).then(
          response => {
            self.keywordChartData = response.body;
            self.modalLoader = false;
            self.loader = false;
            self.processChartData();
          },
          err => {
            self.modalLoader = false;
            self.loader = false;
          }
        );
      });
    },
    drawGaugeChart(word, positive, negative) {
      let self = this;
      let series = [];
      let value1 = Number(positive);
      let value2 = Number(negative);
      if (value1 && value2) {
        let obj = {};
        obj.name = "Positive";
        obj.color = "#7fc557";
        obj.y = value1;
        series.push(obj);
        let obj2 = {};
        obj2.name = "Negative";
        obj2.color = "#fb7b63";
        obj2.y = value2;
        series.push(obj2);
      } else {
        if (!value1) {
          let obj = {};
          obj.name = "Negative";
          obj.color = "#fb7b63";
          obj.y = value2;
          series.push(obj);
          let obj2 = {};
          obj2.name = "other";
          obj2.color = "whitesmoke";
          obj2.y = 100 - value2;
          obj2.dataLabels = { enabled: false };
          series.push(obj2);
        }
        if (!value2) {
          let obj = {};
          obj.name = "Positive";
          obj.color = "#7fc557";
          obj.y = value1;
          series.push(obj);
          let obj2 = {};
          obj2.name = "other";
          obj2.color = "whitesmoke";
          obj2.y = 100 - value1;
          obj2.dataLabels = { enabled: false };
          series.push(obj2);
        }
      }
      this.sentimentChart[word] = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          margin: [0, 0, 0, 0],
          padding: [0, 0, 0, 0],
          height: 110,
          width: 180
        },
        title: {
          text: ""
        },
        credits: {
          enabled: false
        },
        accessibility: {
          point: {
            valueSuffix: "%"
          }
        },
        tooltip: {
          formatter() {
            if (this.point.name == "other") {
              return false;
            }
            var mytooltip = "";
            mytooltip +=
              '<span style="color:' +
              this.point.color +
              '!important">\u25CF</span> ';
            mytooltip += this.point.name;
            mytooltip += " : <b> " + self.format(this.point.y) + "%</b> <br/>";
            return mytooltip;
          }
        },
        plotOptions: {
          series: {
            borderWidth: 0
          },
          pie: {
            dataLabels: {
              enabled: true,
              distance: -15,
              format: "{point.y:.1f}",
              style: {
                fontSize: 11
              },
              color: "black"
            },
            showInLegend: true,
            startAngle: -90,
            endAngle: 90,
            size: "100%",
            center: ["50%", "57%"]
          }
        },
        legend: {
          enabled: false,
          itemStyle: {
            fontSize: 9,
            fontWeight: 1
          }
        },
        series: [
          {
            type: "pie",
            innerSize: "59%",
            data: series
          }
        ]
      };
    },
    getSentiment() {
      let self = this;
      self.loader = true;
      let payload = {
        product_name: "all",
        channel: self.selected_website_channel_array,
        start_date: moment(self.reviewStartDate).format("YYYY-MM-DD"),
        end_date: moment(self.reviewEndDate).format("YYYY-MM-DD"),
        item_category: self.device
      };
      const url = "/api/websites/review_sentiment";
      self.$http.post(url, payload).then(
        response => {
          self.loader = false;
          self.sentimentData = response.body.table;
          for (let [y, td] of response.body.table.entries()) {
            if (td.positive_score == null) {
              td.positive_score = 0;
            }
            if (td.negative_score == null) {
              td.negative_score = 0;
            }
            self.drawGaugeChart(td.word, td.positive_score, td.negative_score);
          }
        },
        err => {
          self.loader = false;
          console.log("err", err);
        }
      );
    },
    refreshReview() {
      let self = this;
      localStorage.reviewStartDate = this.reviewStartDate;
      localStorage.reviewEndDate = this.reviewEndDate;

      if (self.selectedProduct) {
        localStorage.selected_product = JSON.stringify(self.selectedProduct);
        localStorage.checkedReviewsProducts = JSON.stringify(
          self.checkedReviewsProducts
        );
        self.getReviews();
        // if (this.compCheck) {
        //   $("#amdglobal-review-listTable").DataTable().destroy();
        //   this.selectedProduct = [{ key: "https://www.bestbuy.com", label: "Best Buy US", channel: "BESTBUY" }]
        //   this.modifiedSelectedWebsites = [{ key: "https://www.bestbuy.com", label: "Best Buy US", channel: "BESTBUY" }]
        //   this.getCompetitorAnalysisTable();
        // }
      }
    },

    processMultiProductChartData(data, options) {
      let self = this;
      let cat = [];
      let totalData = [];
      let seriesData = [];
      let seriesObj = {};
      let column_colors = ["#47A694", "#54736D", "#265950", "#79A69E"];
      for (let [idx, ds] of data.entries()) {
        cat.push(ds.keyword);
        for (let [idx2, ds2] of ds.models.entries()) {
          if (seriesObj.hasOwnProperty(ds2.name)) {
            seriesObj[ds2.name].push(ds2.count);
          } else {
            seriesObj[ds2.name] = [ds2.count];
          }
        }
        totalData.push(ds.total);
      }
      let i = 0;
      for (let [key, value] of Object.entries(seriesObj)) {
        seriesData.push({ name: key, data: value, color: column_colors[i] });
        i++;
      }
      seriesData.push({
        name: "Total",
        data: totalData,
        type: "line",
        color: "#FCB116",
        lineWidth: 0,
        lineColor: "transparent",
        marker: { symbol: "diamond", radius: 5 }
      });
      self[options.chartKey] = {
        chart: {
          type: "column",
          height: 250,
          style: {
            fontFamily: "Poppins"
          }
        },
        credits: { enabled: false },
        title: {
          text: options.title,
          align: "left",
          style: {
            color: "#065559",
            fontFamily: "Poppins",
            fontWeight: "bold"
          }
        },
        subtitle: {
          text: ""
        },
        xAxis: {
          categories: cat,
          crosshair: true
        },
        legend: {
          enabled: true,
          alignColumns: true,
          align: "right",
          y: -35,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4
        },
        yAxis: {
          min: 0,
          title: {
            text: "Frequency",
            style: {
              color: "#065559"
            }
          }
        },
        tooltip: {
          shared: true,
          valueSuffix: options.tooltipSuffix || "",
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10
          },
          borderRadius: 6,
          backgroundColor: "#ffffff"
        },
        series: seriesData
      };
      setTimeout(function() {
        self.activeMultiChart = true;
      }, 10);
    },

    keywordPieClick(data) {
      let self = this;
      if (self.keywordTableModalData.length) {
        $("#amd-global-review-listkeywordTableModalTable")
          .DataTable()
          .destroy();
      }
      self.keywordTableModalData = [];
      for (let [
        idx,
        ds
      ] of self.reviewsData.graph_data.keyword_review_list.entries()) {
        if (ds.keywords.includes(data.name)) {
          self.keywordTableModalData.push(ds);
        }
      }
      self.initDT("amd-global-review-listkeywordTableModalTable");
      self.keywordModalTitle = data.name;
      self.isKeywordTableModal = true;
    },

    processPieRatingKeywordData(data, options) {
      let self = this;
      let seriesData = [];
      let color_codes = [
        "#47A694",
        "#54736D",
        "#265950",
        "#79A69E",
        "#317367",
        "#54736D",
        "#52BFAB",
        "#84B5AC",
        "#5F827C",
        "#388273",
        "#59CFB7"
      ];
      for (let [idx, ds] of data.entries()) {
        if (options.chartKey == "ratingPieChart")
          seriesData.push({ name: ds.name + " Star", y: ds.value });
        else seriesData.push({ name: ds.name, y: ds.value });
      }
      let plotSeries = { borderWidth: 0 };
      if (options.chartKey == "keyWordPieChart") {
        plotSeries = {
          borderWidth: 0,
          cursor: "pointer",
          point: {
            events: {
              click: function() {
                self.keywordPieClick(this);
              }
            }
          }
        };
      }

      self[options.chartKey] = {
        chart: {
          style: {
            fontFamily: "Poppins"
          }
        },
        title: {
          text: options.title,
          margin: 25,
          verticalAlign: "bottom",
          style: {
            color: "#01695C",
            fontSize: "15px",
            fontWeight: "bold"
          }
        },
        credits: {
          enabled: false
        },
        accessibility: {
          point: {
            valueSuffix: "%"
          }
        },
        tooltip: {
          formatter() {
            var mytooltip = "";
            mytooltip +=
              '<span style="font-size:22px;color:' +
              this.point.color +
              '">\u25CF</span> ';
            mytooltip += this.point.name;
            mytooltip +=
              " : <b> " +
              this.point.y +
              " (" +
              this.point.percentage.toFixed(2) +
              "%)</b> <br/>";
            mytooltip += "Total: <b>" + this.point.total + "</b>";
            return mytooltip;
          },
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10
          },
          borderRadius: 6,
          backgroundColor: "#ffffff"
        },
        plotOptions: {
          series: plotSeries,
          pie: {
            dataLabels: {
              enabled: true,
              useHTML: true,
              formatter: function() {
                self.pieTotal = this.point.total;

                return (
                  '<span style="color:white;font-size:11px;font-weight:normal;">' +
                  self.format(this.point.percentage.toFixed()) +
                  "%</span>"
                );
              },
              distance: -30,
              style: {
                fontSize: 11
              }
            },
            showInLegend: true,
            size: "100%",
            innerSize: "50%",
            colors: color_codes
          }
        },
        legend: {
          enabled: true,
          alignColumns: true,
          layout: "horizontal",
          align: "right",
          y: -7,
          x: -30,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 20,
          itemMarginBottom: 6,
          margin: 15,
          marginLeft: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4
        },
        series: [
          {
            type: "pie",
            data: seriesData
          }
        ]
      };
    },
    getReviews() {
      let self = this;
      self.reviewLoader = true;
      let url, payload;

      //payload mapping and url modifications for non-competitor analysis
      // if (!this.compCheck) {
      payload = {
        start_date: moment(self.reviewStartDate).format("YYYY-MM-DD"),
        end_date: moment(self.reviewEndDate).format("YYYY-MM-DD"),
        interval: self.revInterval,
        client: "AMD",
        item_category: self.device,
        channel: self.selected_website_channel_array
      };
      if (self.brandFilter.length) {
        payload["brand"] = self.brandFilter;
      }
      if (self.cpuFilter.length) {
        payload["processor"] = self.cpuFilter;
      }
      if (self.reviewsRatingInput) {
        payload["rating"] = {};
        if (self.reviewsRatingExp != "between") {
          payload["rating"][self.reviewsRatingExp] = self.reviewsRatingInput;
        } else {
          payload["rating"]["lte"] = self.reviewsRatingInput2;
          payload["rating"]["gte"] = self.reviewsRatingInput;
        }
      }
      const allProductName = JSON.parse(JSON.stringify(self.productOptions));
      const processorSeries = [];
      if (self.selectedProduct.length) {
        payload["product_name"] = self.selectedProduct;
      }
      if (
        self.ratingInput1 ||
        self.fourKSeries ||
        self.fiveKSeries ||
        self.sixKSeries ||
        self.sevenSeries
      ) {
        if (self.fourKSeries) processorSeries.push(4);
        if (self.fiveKSeries) processorSeries.push(5);
        if (self.sixKSeries) processorSeries.push(6);
        if (self.sevenSeries) processorSeries.push(7);
        if (self.pickProduct) {
          if (self.selectedProduct.length)
            payload["product_name"] = self.selectedProduct;
          else {
            payload["product_name"] = allProductName.map(val => val.key);
          }
        } else {
          payload["product_name"] = allProductName.map(val => val.key);
        }
      }
      payload["processor_model"] = processorSeries;
      if (Object.keys(self.reviewsData).length) {
        $("#amdglobal-review-listTable")
          .DataTable()
          .destroy();
      }
      self.reviewsData = {};

      url = "/api/reviews/list";
      // }

      //payload and url for competitor analysis
      // if (this.compCheck) {
      //   url = '/api/reviews/comeptitor_list';
      //   payload = {
      //     start_date: moment(self.reviewStartDate).format("YYYY-MM-DD"),
      //     end_date: moment(self.reviewEndDate).format("YYYY-MM-DD"),
      //     channel: ["BESTBUY"],
      //     client: "AMD"
      //   }
      // }

      self.$http.post(url, payload).then(
        response => {
          self.reviewLoader = false;
          self.reviewsData = response.body;

          //plot graph data only for non-competitor analysis
          // if (!this.compCheck) {
          if (response.body.graph_data.count_data.length) {
            if (this.device === "cpu" || this.device === "gpu") {
              this.countDataFlag = false;
            } else {
              this.countDataFlag = true;
              self.processMultiProductChartData(
                response.body.graph_data.count_data,
                {
                  type: "count",
                  chartKey: "multiProdChart",
                  title: "Number of 1 and 2 Star Reviews by CPU family"
                }
              );
            }
          } else this.countDataFlag = false;

          if (response.body.graph_data.percent_data.length) {
            if (this.device === "cpu" || this.device === "gpu") {
              this.percentDataFlag = false;
            } else {
              this.percentDataFlag = true;
              self.processMultiProductChartData(
                response.body.graph_data.percent_data,
                {
                  tooltipSuffix: "%",
                  type: "percent",
                  chartKey: "percentChart",
                  title: "Percentage of 1 and 2 Star Reviews by CPU family"
                }
              );
            }
          } else this.percentDataFlag = false;

          if (response.body.graph_data.all_keyword_data.length) {
            if (this.device === "cpu" || this.device === "gpu") {
              this.allKeywordDataFlag = false;
            } else {
              this.allKeywordDataFlag = true;
              self.processPieRatingKeywordData(
                response.body.graph_data.all_keyword_data,
                {
                  chartKey: "keyWordPieChart",
                  title: "Keyword Density"
                }
              );
            }
          } else this.allKeywordDataFlag = false;

          if (response.body.graph_data.all_rating_data.length) {
            if (this.device === "cpu" || this.device === "gpu") {
              this.allRatingDataFlag = false;
            } else {
              this.allRatingDataFlag = true;
              self.processPieRatingKeywordData(
                response.body.graph_data.all_rating_data,
                {
                  chartKey: "ratingPieChart",
                  title: "Ratings Distribution"
                }
              );
            }
          } else this.allRatingDataFlag = false;
          // }

          if (response.body.data.length) {
            this.reviewTableDataFlag = true;
            this.$nextTick(() => {
              this.checkGPUFlag = this.checkReviewsGPU();
              self.initDT("amdglobal-review-listTable");
            });
          } else this.reviewTableDataFlag = false;
        },
        err => {
          self.reviewLoader = false;
          console.log("err", err);
        }
      );
    },
    initDT(id) {
      let self = this;
      let pageLength = {
        "amdglobal-review-listTable": 10,
        "amd-global-review-listkeywordTableModalTable": 10
      };
      let bLengthChange = {
        "amdglobal-review-listTable": true,
        "amd-global-review-listkeywordTableModalTable": true
      };
      let searchable = {
        "amdglobal-review-listTable": true,
        "amd-global-review-listkeywordTableModalTable": false
      };
      self.$nextTick(function() {
        if (self.reviewsData.data.length) {
          $("#" + id).DataTable({
            language: {
              search: "",
              paginate: {
                first: "",
                previous: "<",
                next: ">",
                last: ""
              },
              lengthMenu: "<h5>Show entries</h5> _MENU_"
            },
            // dom: '<"top">frt<"bottom"l>p<"clear">',
            pagingType: "full_numbers",
            searching: true,
            bLengthChange: bLengthChange[id],
            pageLength: pageLength[id],
            autoWidth: false,
            initComplete: function() {
              this.api()
                .columns()
                .every(function() {
                  var column = this;
                  var select = $(
                    '<select><option value="">All</option></select>'
                  )
                    .appendTo($(column.footer()).empty())
                    .on("change", function() {
                      var val = $.fn.DataTable.util.escapeRegex($(this).val());
                      column
                        .search(val ? "^" + val + "$" : "", true, false)
                        .draw();
                    });
                  if (this.index() == 4) return;
                  let arr = [];
                  let sortedArr = [];
                  column
                    .data()
                    .unique()
                    .sort()
                    .each(function(d, j) {
                      if (!d.includes("<span") && !d.includes("<div")) {
                        arr.push(d);
                      } else {
                        var myVal = $(d).text();
                        arr.push(myVal);
                      }
                    });

                  sortedArr = arr.sort((a, b) =>
                    a.localeCompare(
                      b,
                      navigator.languages[0] || navigator.language,
                      {
                        numeric: true,
                        ignorePunctuation: true
                      }
                    )
                  );
                  for (let [idx, ds] of sortedArr.entries()) {
                    select.append(
                      '<option value="' + ds + '">' + ds + "</option>"
                    );
                  }
                });
            }
          });
          let search = require("../../public/Icons_SVG/Search.svg");
          if (searchable[id])
            $("#" + id + "_filter > label").append(
              `<div><img src='${search}' /></div>`
            );
          if (searchable[id])
            $("#" + id + "_filter > label > input").attr(
              "placeholder",
              "Search"
            );
          $("#" + id + "_length > label > select").removeClass();
        }
      });

      setTimeout(function() {
        if (!searchable[id])
          $("#" + id + "_filter").attr("style", "display:none");
      }, 10);
    },
    getProducts() {
      let self = this;
      self.loader = true;
      self.productOptions = [];
      self.selectedProduct = [];
      self.productOptionsFull = [];
      const url = "/api/websites/website_products";
      let payload = {};
      payload["website"] = this.selected_website_array;
      payload["item_category"] = self.device;
      payload["start_date"] = moment(self.reviewStartDate).format("YYYY-MM-DD");
      payload["end_date"] = moment(self.reviewEndDate).format("YYYY-MM-DD");

      self.$http.post(url, payload).then(
        response => {
          self.loader = false;
          self.errorInProduct = false;
          if (!response.body.data.length) {
            self.errorInProduct = true;
            return;
          }
          self.productOptionsFull = response.body.data;

          self.filterKeys.brand = response.body.brand_list.sort();
          self.filterKeys.processor_type = response.body.processor_list.sort();

          if (localStorage.selected_product && !self.updateSelectedProduct)
            self.selectedProduct = JSON.parse(localStorage.selected_product);
          else {
            self.selectedProduct = [];
            localStorage.selected_product = JSON.stringify(
              self.selectedProduct
            );
          }
          self.filterActions();
          self.updateSelectedProduct = false;
        },
        err => {
          self.loader = false;
          self.errorInProduct = true;
          console.log("err", err);
        }
      );
    },

    getCompPage() {
      //toggle competitor page and set it to the local storage
      this.compCheck = !this.compCheck;
      localStorage.comp_check = this.compCheck;
      this.selectedWebsites = [
        {
          key: "https://www.bestbuy.com",
          label: "Best Buy US",
          channel: "BESTBUY"
        }
      ];
      this.modifiedSelectedWebsites = [
        {
          key: "https://www.bestbuy.com",
          label: "Best Buy US",
          channel: "BESTBUY"
        }
      ];

      //fetch data for competitor page toggle
      $("#amdglobal-review-listTable")
        .DataTable()
        .destroy();
      this.siteDeviceChange();
    },

    getCompetitorAnalysisTable() {
      this.loader = true;
      let url = "/api/competitive/analysis";
      let payload = {
        start_date: moment(this.reviewStartDate).format("YYYY-MM-DD"),
        end_date: moment(this.reviewEndDate).format("YYYY-MM-DD"),
        channel: this.selected_website_channel_array,
        item_category: this.device
      };

      this.$http
        .post(url, payload)
        .then(res => {
          this.competitorTableHeader = res.body.header;
          this.competitorTableData = res.body.data;

          this.loader = false;
        })
        .catch(err => {
          this.loader = false;
          console.log(err);
        });
    },

    filterActions() {
      this.productOptions = [];
      let brandCheck = true;
      let cpuCheck = true;
      let ratingCheck = true;
      let seriesCheck = true;

      let ratingExpMapper = {
        eq: function(a, b) {
          return a == b;
        },
        gt: function(a, b) {
          return b > a;
        },
        gte: function(a, b) {
          return b >= a;
        },
        lt: function(a, b) {
          return b < a;
        },
        lte: function(a, b) {
          return b <= a;
        },
        between: function(a1, a2, b) {
          return b >= a1 && b <= a2;
        }
      };

      let processor_model_list = [];
      if (this.fourKSeries) processor_model_list.push("4");
      if (this.fiveKSeries) processor_model_list.push("5");
      if (this.sixKSeries) processor_model_list.push("6");
      if (this.sevenSeries) processor_model_list.push("7");
      for (let [ii, rr] of this.productOptionsFull.entries()) {
        if (this.brandFilter)
          brandCheck = this.brandFilter.includes(rr.brand_name);
        if (this.cpuFilter)
          cpuCheck = this.cpuFilter.includes(rr.processor_type);
        if (this.ratingExp != "between" && this.ratingInput1)
          ratingCheck = ratingExpMapper[this.ratingExp](
            this.ratingInput1,
            rr.rating
          );
        else if (
          this.ratingExp == "between" &&
          this.ratingInput1 &&
          this.ratingInput1
        )
          ratingCheck = ratingExpMapper[this.ratingExp](
            this.ratingInput1,
            this.ratingInput2,
            rr.rating
          );

        seriesCheck = processor_model_list.includes(rr.processor_model[0]);

        if (processor_model_list.length == 0) seriesCheck = true;
        if (this.brandFilter.length == 0) brandCheck = true;
        if (this.cpuFilter.length == 0) cpuCheck = true;

        if (brandCheck && cpuCheck && ratingCheck && seriesCheck) {
          this.productOptions.push(rr);
        }
      }
      this.refreshReview();
    },

    format(v) {
      return this.$options.filters.format(v);
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
#amdglobal-review-listTable_filter > label {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

#amdglobal-review-listTable_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}

#amdglobal-review-listTable_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}

#amdglobal-review-listTable_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}

#amdglobal-review-listTable_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#amdglobal-review-listTable_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#amdglobal-review-listTable .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}

#amdglobal-review-listTable_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#amdglobal-review-listTable_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg)
    brightness(103%) contrast(104%);
}

#amdglobal-review-listTable_filter div.filter_icon {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  background-color: var(--background);
}

#amdglobal-review-listTable_filter div.filter_icon img {
  height: 23px;
  filter: brightness(0) saturate(100%) invert(24%) sepia(18%) saturate(2530%)
    hue-rotate(138deg) brightness(98%) contrast(95%);
}

#amdglobal-review-listTable_paginate {
  position: relative;
  top: 12px;
  z-index: 100;
  float: right;
  width: 50vw;
}

#amdglobal-review-listTable_info {
  position: relative;
  top: 9px;
  left: 324px;
  z-index: 100;
  float: right;
  width: 50vw;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}

#amdglobal-review-listTable_length {
  /* position: relative;
  top: 90px;
  left: 30px;
  z-index: 100;
  width: 50vw; */
}

#amdglobal-review-listTable_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}

#amdglobal-review-listTable_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}

#amdglobal-review-listTable_length select {
  width: 30px;
  height: 100%;
  text-align-last: center;
  border-radius: 5px;
  margin-right: 10px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background-color: #fff !important;
  color: var(--primary_brand-80);
}

#amdglobal-review-listTable_paginate .page-link {
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}

#amdglobal-review-listTable_paginate ul.pagination li.active {
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}

#amdglobal-review-listTable {
  border-radius: 20px 20px 0 0;
}

#amdglobal-review-listTable .thead-normal,
#amdglobal-review-listTable .thead-normal tr:first-child,
#amdglobal-review-listTable .thead-normal > tr:first-child > th:first-child {
  background-color: var(--background) !important;
  border-radius: 21px 0 0 0;
  border-left: 1px solid var(--base_color-20) !important;
}

#amdglobal-review-listTable .thead-normal > tr:first-child > th:last-child {
  border-radius: 0 21px 0 0;
}

#amdglobal-review-listTable .thead-normal > tr:first-child > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 5px 25px;
  color: rgb(78 78 78) !important;
  border-top: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
}

#amdglobal-review-listTable .thead-normal > tr:last-child > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 0px 25px 5px 25px !important;
  color: rgb(78 78 78) !important;
}

#amdglobal-review-listTable th select {
  background-color: #fff !important;
  filter: brightness(99%);
  border: 1px solid #b1b1b1 !important;
  width: 100%;
  color: var(--primary_brand-60);
  font-size: 10px;
  border-radius: 7px;
  height: 33px;
}

#amdglobal-review-listTable tfoot th {
  background-color: var(--background) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#amdglobal-review-listTable tfoot th:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#amdglobal-review-listTable tbody td {
  /* border-left: 1px solid var(--base_color-20) !important; */
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  font-size: 13px !important;
  font-family: "Heebo", sans-serif !important;
}

#amdglobal-review-listTable tbody td:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#amdglobal-review-listTable .even td {
  background: #fff !important;
}

#amdglobal-review-listTable .odd td {
  background: #fff !important;
  /* filter: brightness(110%); */
}

/* #amdglobal-review-listTable_wrapper .bottom {
  margin-bottom: -30px;
} */
#amdglobal-review-listTable_wrapper .row:last-child {
  margin-bottom: 15px;
}

#amdglobal-review-listTable_wrapper .scrolledDataTable {
  border-left: none;
  border-right: none;
}

#amdglobal-review-listTable .thead-normal > tr > th.sorting:before {
  font-size: 15px;
  bottom: 57%;
  color: var(--base_color-80);
}

#amdglobal-review-listTable .thead-normal > tr > th.sorting:after {
  font-size: 15px;
  color: var(--base_color-80);
}

#amdglobal-review-listTable_wrapper
  .scrolledDataTable::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

#amdglobal-review-listTable_wrapper .scrolledDataTable::-webkit-scrollbar {
  height: 10px;
}

#amdglobal-review-listTable_wrapper
  .scrolledDataTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--background);
}

#amdglobal-review-listTable_wrapper
  .scrolledDataTable::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}

#amd-global-review-listkeywordTableModalTable_filter > label {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

#amd-global-review-listkeywordTableModalTable_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}

#amd-global-review-listkeywordTableModalTable_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}

#amd-global-review-listkeywordTableModalTable_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}

#amd-global-review-listkeywordTableModalTable_filter
  input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#amd-global-review-listkeywordTableModalTable_filter
  input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#amd-global-review-listkeywordTableModalTable .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}

#amd-global-review-listkeywordTableModalTable_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#amd-global-review-listkeywordTableModalTable_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg)
    brightness(103%) contrast(104%);
}

#amd-global-review-listkeywordTableModalTable_filter div.filter_icon {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  background-color: var(--background);
}

#amd-global-review-listkeywordTableModalTable_filter div.filter_icon img {
  height: 23px;
  filter: brightness(0) saturate(100%) invert(24%) sepia(18%) saturate(2530%)
    hue-rotate(138deg) brightness(98%) contrast(95%);
}

/* #amd-global-review-listkeywordTableModalTable_paginate {
  position: relative;
  top: 70px;
  z-index: 100;
  float: right;
  width: 50vw;
} */
#amd-global-review-listkeywordTableModalTable_info {
  position: relative;
  /* top: 65px; */
  left: 514px;
  z-index: 100;
  float: right;
  width: 50vw;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}

#amd-global-review-listkeywordTableModalTable_length {
  position: relative;
  top: 30px;
  z-index: 100;
  width: 50vw;
}

#amd-global-review-listkeywordTableModalTable_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}

#amd-global-review-listkeywordTableModalTable_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}

#amd-global-review-listkeywordTableModalTable_length select {
  width: 30px;
  height: 100%;
  text-align-last: center;
  border-radius: 5px;
  margin-right: 10px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background-color: #fff !important;
  color: var(--primary_brand-80);
}

#amd-global-review-listkeywordTableModalTable_paginate .page-link {
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}

#amd-global-review-listkeywordTableModalTable_paginate ul.pagination li.active {
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}

#amd-global-review-listkeywordTableModalTable {
  border-radius: 20px 20px 0 0;
}

#amd-global-review-listkeywordTableModalTable .thead-normal,
#amd-global-review-listkeywordTableModalTable .thead-normal tr:first-child,
#amd-global-review-listkeywordTableModalTable
  .thead-normal
  > tr:first-child
  > th:first-child {
  background-color: var(--background) !important;
  border-radius: 21px 0 0 0;
  border-left: 1px solid var(--base_color-20) !important;
}

#amd-global-review-listkeywordTableModalTable
  .thead-normal
  > tr:first-child
  > th:last-child {
  border-radius: 0 21px 0 0;
}

#amd-global-review-listkeywordTableModalTable
  .thead-normal
  > tr
  > th.sorting:before {
  font-size: 15px;
  bottom: 57%;
  color: var(--base_color-80);
}

#amd-global-review-listkeywordTableModalTable
  .thead-normal
  > tr
  > th.sorting:after {
  font-size: 15px;
  color: var(--base_color-80);
}

#amd-global-review-listkeywordTableModalTable
  .thead-normal
  > tr:first-child
  > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 5px 25px;
  color: rgb(78 78 78) !important;
  border-top: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
}

#amd-global-review-listkeywordTableModalTable
  .thead-normal
  > tr:last-child
  > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 0px 25px 5px 25px !important;
  color: rgb(78 78 78) !important;
}

#amd-global-review-listkeywordTableModalTable th select {
  background-color: #fff !important;
  filter: brightness(99%);
  border: 1px solid #b1b1b1 !important;
  width: 100%;
  color: var(--primary_brand-60);
  font-size: 10px;
  border-radius: 7px;
  height: 33px;
}

#amd-global-review-listkeywordTableModalTable tfoot th {
  background-color: var(--background) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#amd-global-review-listkeywordTableModalTable tfoot th:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#amd-global-review-listkeywordTableModalTable tbody td {
  /* border-left: 1px solid var(--base_color-20) !important; */
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  font-size: 13px !important;
  font-family: "Heebo", sans-serif !important;
}

#amd-global-review-listkeywordTableModalTable tbody td:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#amd-global-review-listkeywordTableModalTable .even td {
  background: #fff !important;
}

#amd-global-review-listkeywordTableModalTable .odd td {
  background: #fff !important;
  /* filter: brightness(110%); */
}

#amd-global-review-listkeywordTableModalTable_wrapper {
  margin-top: -32px;
}

/* #amd-global-review-listkeywordTableModalTable_wrapper .row:last-child {
  margin-bottom: -30px;
} */
#amd-global-review-listkeywordTableModalTable_wrapper .scrolledDataTable {
  border-left: none;
  border-right: none;
}

#amd-global-review-listkeywordTableModalTable_wrapper
  .scrolledDataTable::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

#amd-global-review-listkeywordTableModalTable_wrapper
  .scrolledDataTable::-webkit-scrollbar {
  height: 10px;
}

#amd-global-review-listkeywordTableModalTable_wrapper
  .scrolledDataTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--background);
}

#amd-global-review-listkeywordTableModalTable_wrapper
  .scrolledDataTable::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}

.modal-title {
  font-weight: 600 !important;
  font-family: "poppins";
}

.modal-header {
  background: var(--primary_brand-20) !important;
  color: var(--base_color);
  border: none;
  display: flex !important;
  justify-content: start !important;
  padding-bottom: 1rem !important;
  font-family: "poppins";
  border-radius: 5px 0px 0px 0px !important;
}

.modal-header .close {
  color: black;
  text-shadow: none;
  position: absolute;
  top: -2px;
  right: -6px;
  font-size: 30px;
  background: var(--primary_brand-10);
  opacity: inherit;
  padding: 5px 10px;
  border-radius: 25px;
}
</style>

<style scoped>
.inputBoxTitle {
  color: var(--primary_brand);
  font-size: 16px;
  margin-bottom: 5px;
  font-family: "poppins";
}

.selectedProduct {
  background: #8e8d8d !important;
  color: White !important;
}

.lastUpdated {
  background: var(--base_color-60);
  color: white;
  font-size: 15px;
  line-height: 32px;
  padding: 6px 12px;
  border-radius: 4px;
}

.cardper {
  float: right;
  position: absolute;
  right: 11px;
  bottom: 0;
  font-size: 29px;
  color: white;
}

.space-between-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;

  padding-bottom: 5px;
}

.space-between-header select {
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}

.space-between-header h3 {
  color: #4e4e4e;
  margin-bottom: 0;
  line-height: 31px;
}

.mycols:first-child {
  padding-right: 2px !important;
}

.mycols:last-child {
  padding-left: 2px;
}

.mycols:not(:first-child):not(:last-child) {
  padding-left: 2px;
  padding-right: 2px;
}

.customselect {
  height: 34px;
  border-radius: 0;
  background: white;
  border: 1px solid silver;
  padding-left: 11px;
  padding-right: 11px;
  margin-right: 5px;
}

.eachProduct:hover {
  background: #d4d4d4;
}

.custom_websiteMenu {
  border: 1px solid silver;
  background: white;
  width: max-content;
  position: absolute;
  z-index: 1;
  height: 300px;
  overflow-y: scroll;
  margin-left: -5px;
  border-radius: 0px 0px 5px 5px;
}

.custom_websiteMenuItems {
  font-size: 11px;
  color: var(--primary_brand);
}

.custom_optgroup {
  font-weight: bolder;
  padding-left: 9px;
  font-size: 13px;
}

.custom_option {
  padding: 8px 8px 8px 18px;
  display: flex;
  align-items: center;
  font-family: "heebo" !important;
  border-bottom: 1px solid var(--base_color-20);
}

.custom_option input {
  margin-right: 5px;
  font-size: 11px;
  accent-color: var(--primary_brand);
  width: 15px;
  height: 15px;
  font-family: "poppins";
}

.custom_option:hover {
  background: var(--base_color-10) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.custom_option.active {
  background: var(--primary_brand-60);
  color: white;
  font-weight: bolder;
}

.custom_dropdown {
  text-transform: uppercase;
  -youbkit-touch-callout: none;
  /* iOS Safari */
  -youbkit-user-select: none;
  /* Chrome 6.0+, Safari 3.1+, Edge & Opera 15+ */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE 10+ and Edge */
  user-select: none;
}

.datebox {
  width: 14% !important;
}

.custom_dropdown_wrap {
  cursor: pointer;
  display: flex;
  border: 1px solid silver;
  background: white;
  justify-content: space-between;
  padding: 7px;
  height: 30px;
}

.custom_dropdown_title {
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#keyword_newtable {
  --border: 1px solid var(--base_color-20);
  border-radius: 10px;
  border-spacing: 0;
  border-collapse: separate;
  border: var(--border);
  overflow: hidden;
}

#keyword_newtable th:not(:last-child),
#keyword_newtable td:not(:last-child) {
  border-right: var(--border) !important;
}

#keyword_newtable > thead > tr:not(:last-child) > th,
#keyword_newtable > thead > tr:not(:last-child) > td,
#keyword_newtable > tbody > tr:not(:last-child) > th,
#keyword_newtable > tbody > tr:not(:last-child) > td,
#keyword_newtable > tfoot > tr:not(:last-child) > th,
#keyword_newtable > tfoot > tr:not(:last-child) > td,
#keyword_newtable > tr:not(:last-child) > td,
#keyword_newtable > tr:not(:last-child) > th,
#keyword_newtable > thead:not(:last-child),
#keyword_newtable > tbody:not(:last-child),
#keyword_newtable > tfoot:not(:last-child) {
  border-bottom: var(--border) !important;
}

#keyword_newtable th {
  background: var(--background);
  padding: 0.6rem !important;
  font-size: 14px !important;
  font-family: "Poppins", sans-serif !important;
}

#keyword_newtable td {
  padding: 4px !important;
  font-size: 14px !important;
  font-family: "Heebo", sans-serif !important;
}

#competitor_table {
  --border: 1px solid var(--base_color-20);
  border-radius: 10px;
  border-spacing: 0;
  border-collapse: separate;
  border: var(--border);
  overflow: hidden;
}

#competitor_table th:not(:last-child),
#competitor_table td:not(:last-child) {
  border-right: var(--border) !important;
}

#competitor_table > thead > tr:not(:last-child) > th,
#competitor_table > thead > tr:not(:last-child) > td,
#competitor_table > tbody > tr:not(:last-child) > th,
#competitor_table > tbody > tr:not(:last-child) > td,
#competitor_table > tfoot > tr:not(:last-child) > th,
#competitor_table > tfoot > tr:not(:last-child) > td,
#competitor_table > tr:not(:last-child) > td,
#competitor_table > tr:not(:last-child) > th,
#competitor_table > thead:not(:last-child),
#competitor_table > tbody:not(:last-child),
#competitor_table > tfoot:not(:last-child) {
  border-bottom: var(--border) !important;
}

#competitor_table th {
  background: var(--background);
  padding: 0.6rem !important;
  font-size: 14px !important;
  font-family: "Poppins", sans-serif !important;
  text-align: center;
}

#competitor_table td {
  padding: 4px !important;
  font-size: 14px !important;
  font-family: "Heebo", sans-serif !important;
  text-transform: capitalize;
}

#competitor_table td:first-child {
  background-color: var(--secondary_competitor-10);
}

/* revamp code  */
#sov {
  font-family: "Poppins", sans-serif !important;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem !important;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

/* select  */
select {
  font-family: "Poppins", sans-serif;
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}

.searchInput input {
  height: 35px !important;
  margin-right: -5px !important;
  font-size: 14px !important;
  border-color: var(--primary_brand-60) !important;
  font-family: "poppins";
}

.searchInput input::placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input:focus {
  box-shadow: none !important;
  border-color: var(--primary_brand) !important;
  font-family: "poppins";
}

.searchIcon {
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  font-family: "poppins";
  background-color: var(--primary_brand);
}

.searchIcon img {
  width: 25px;
  margin: 10px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg)
    brightness(103%) contrast(104%);
}

.checkbox-btn {
  margin-right: 6px;
  height: 35px !important;
  display: flex;
  align-items: center;
  border: none;
  background-color: var(--base_color-10);
  border-radius: 5px;
  color: #000;
  padding: 0px 10px;
  font-family: "poppins";
}

.checkbox-btn span {
  padding: 0 5px;
  margin-left: 10px;
  font-family: "poppins";
}

.checkbox-btn input {
  margin: 4px;
  font-size: 11px;
  accent-color: #fff;
  width: 15px;
  height: 15px;
  font-family: "poppins";
}

.productListCheckbox {
  display: flex;
  align-items: center;
}

.productListCheckbox input {
  /* font-size: 11px !important; */
  accent-color: var(--primary_brand);
  width: 16px !important;
  height: 16px !important;
}

.productListCheckbox input[type="checkbox"] {
  border: 1px solid var(--primary_brand) !important;
}

.productListCheckbox span {
  margin-left: 10px;
  /* font-weight: 600; */
  font-family: "Poppins", sans-serif !important;
}

.eachProduct:hover {
  background: var(--base_color-20);
}

.checkboxAccent input {
  accent-color: var(--primary_brand);
}

.productScroll {
  padding-top: 0px;
  cursor: pointer;
  height: 300px;
  overflow-y: scroll;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: var(--base_color-10);
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

.ratingSection {
  display: flex;
  justify-content: start;
  padding-right: 15px;
  padding-left: 15px;
  width: 100%;
}

.ratingSectionItem {
  width: 25%;
}

.dateBadge {
  background: var(--primary_brand);
}

.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .btn-outline-secondary.dropdown-toggle {
  color: #ffffff;
  background-color: var(--primary_brand-80);
  border-color: var(--primary_brand-80);
  height: 35px;
  border-radius: 5px;
  font-weight: 600;
}

.btn-outline-secondary {
  height: 35x;
  line-height: 20px;
  color: var(--primary_brand);
  background: var(--primary_brand-10);
  border: 1px solid var(--primary_brand-10);
}

.btn-group {
  background: var(--primary_brand-10);
  border-radius: 5px;
}

.datePickerBadge {
  margin-left: 6px;
  height: 35px;
  border: 1px solid #c5c5c5;
  border-right: none;
  margin-right: -5px;
  z-index: 3;
  background: #fff;
  color: black;
  border-radius: 5px 0px 0px 5px;
}

.exportButton {
  margin-left: 6px;
  height: 35px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px;
  font-weight: 600;
  padding: 0px 25px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.exportButton:hover {
  color: white !important;
  background: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  margin-bottom: -20px !important;
}

.noDataWarning {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--red-80) !important;
  letter-spacing: 0.6px !important;
  margin-bottom: 0px !important;
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.backgroundColorCheck {
  fill: red;
}

.backIcon {
  filter: brightness(0) saturate(100%) invert(98%) sepia(0%) saturate(206%)
    hue-rotate(268deg) brightness(116%) contrast(100%);
}
</style>
<style>
.customMultiselect .multiselect__placeholder {
  margin-bottom: 6px !important;
  padding: 0px !important;
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  max-height: 36px !important;
  overflow-y: auto;
  font-family: "poppins";
}

.customMultiselect .multiselect__input {
  border: var(--base_color-20) !important;
  height: 30px !important;
}

.customMultiselect .multiselect__input:focus {
  outline: none !important;
}

.customMultiselect .multiselect__select {
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
  top: 56% !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag {
  background: var(--primary_brand-80) !important;
  margin-bottom: 0px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
  color: #fff !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
  border: 1px solid var(--base_color-40) !important;
  border-top: none !important;
  font-family: "poppins";
}

.customMultiselect
  .multiselect__option--selected.multiselect__option--highlight {
  background: var(--red) !important;
  color: var(--white) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
  background: var(--base_color-20) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__element {
  color: var(--primary_brand-80) !important;
  border-bottom: 1px solid var(--base_color-20);
  font-family: "poppins";
}

.customMultiselect .multiselect__option--group {
  background-color: #44777a !important;
  color: white !important;
  font-size: 16px;
}

.customMultiselect .multiselect__option--highlight::after {
  font-size: 10px !important;
  padding-inline: 6px !important;
}

/* width */
.customMultiselect ::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
  background: var(--base_color-20);
  border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

.modal-title {
  font-weight: 600 !important;
  font-family: "poppins";
}

.modal-header {
  background: var(--primary_brand-20) !important;
  color: var(--base_color);
  border: none;
  font-family: "poppins";
  display: flex !important;
  justify-content: start !important;
  padding-bottom: 1rem !important;
}

.modal-header .close {
  color: black;
  text-shadow: none;
  position: absolute;
  top: -2px;
  right: -6px;
  font-size: 30px;
  background: var(--primary_brand-10);
  opacity: inherit;
  padding: 5px 10px;
  border-radius: 25px;
}

.lineBetween {
  padding-top: 10px !important;
  border-bottom: 1px solid var(--base_color-20) !important;
}

@media only screen and (max-width: 1700px) {
  .primarycolor {
    padding: 5px 10px !important;
  }

  .custom_dropdown {
  }
}
</style>
